import React, { useEffect } from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { useSelector } from 'react-redux'

// import { navigationOptionsDefault } from '../config/navigation'

import StartOverviewScreen from '../screens/start/StartOverviewScreen'
import StartOverviewChildrenScreen from '../screens/start/StartOverviewChildrenScreen'
import StartOverviewAdultsScreen from '../screens/start/StartOverviewAdultsScreen'
import StartOverviewCaredependentsScreen from '../screens/start/StartOverviewCaredependentsScreen'

const Stack = createStackNavigator()

type Props = {
  // navigation: any
}

const StartNavigator = (props: Props) => {
  const { patientGroup } = useSelector((state) => state.user)

  return (
    <Stack.Navigator
      initialRouteName="Start"
      screenOptions={{
        animationEnabled: false,
        // ...navigationOptionsDefault
      }}
    >
      <Stack.Screen
        name="Start"
        component={StartOverviewScreen}
        options={{ headerShown: false }}
      />

      {/* path: 'start-overview-children', */}
      <Stack.Screen
        name="StartOverviewChildren"
        component={StartOverviewChildrenScreen}
        options={{ headerShown: false }}
      />

      {/* path: 'start-overview-adults', */}
      <Stack.Screen
        name="StartOverviewAdults"
        component={StartOverviewAdultsScreen}
        // options={{  }}
      />

      {/* path: 'start-overview-caredependents' */}
      <Stack.Screen
        name="StartOverviewCaredependents"
        component={StartOverviewCaredependentsScreen}
        // options={{  }}
      />
    </Stack.Navigator>
  )
}

export default StartNavigator
